import { useEffect, useState } from 'react';
import { calculateDifference, isCountdownComplete } from '../../common/dateUtils';

export const useCountdown = ({
  startTime,
  onComplete,
}: {
  startTime: number;
  onComplete?: () => void | NodeJS.Timeout;
}) => {
  const [dateParts, setDateParts] = useState(calculateDifference(Date.now(), startTime));
  useEffect(() => {
    let timeout: undefined | NodeJS.Timeout | void;
    const interval = setInterval(() => {
      setDateParts(calculateDifference(Date.now(), startTime));
    }, 200);
    if (isCountdownComplete(dateParts)) {
      clearInterval(interval);
      timeout = onComplete?.();
    }

    return () => {
      clearInterval(interval);
      if (timeout) clearTimeout(timeout);
    };
  }, [dateParts, onComplete, startTime]);
  return dateParts;
};
